module.exports = __webpack_public_path__ + "img/association-road-1.a306301d.png";